import { render } from "./TemplateDetail.vue?vue&type=template&id=db5e001c"
import script from "./TemplateDetail.vue?vue&type=script&lang=js"
export * from "./TemplateDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__